// to mm:ss or hh:mm:ss format
export function convertSecondsToDisplayFormat(seconds) {

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secondsValue = Math.floor(seconds % 60);

  return `${hours ? `${hours}:` : ''}${minutes < 10 ? `0${minutes}` : minutes}:${secondsValue < 10 ? `0${secondsValue}` : secondsValue}`;

}

export function determineTrackName(tracks, object) {

  const objectTypeCount = tracks.filter((track) => track.type === object.type).length;

  return `${object.type} #${objectTypeCount + 1}`;

}